<template lang="pug">
  div
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required|max:6", v-slot="{ errors }")
          app-label(label="N° do Ofício:", :required="true")
          el-input.input(
            v-model="numeroOficio"
            :class="{'erro' : errors.length}"
            :onkeypress="onlyInputNumbers"
            :disabled="isMatricula"
          )
            span(slot="append") {{ oficioSuffix }}
          span.help.erro {{ errors[0] }}
      el-col(:span="12" v-if="!isMatricula").container-input
        app-label(label="Data de Emissão do Ofício:", :required="true")
        el-input.input(
          v-model="dataEmissao"
          :disabled="true"
        )
      el-col(:span="12" v-if="isMatricula").container-input
        app-label(label="Nome do cartório:", :required="true")
        el-input.input(
          v-model="oficio.cartorio.nome"
          :disabled="true"
        )
      el-col(:span="12" v-if="isMatricula").container-input
        app-label(label="Município:", :required="true")
        el-input.input(
          v-model="municipioNome"
          :disabled="true"
        )
</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'
import utils from '@/utils/utils'
import AppOnlyInputNumbers from '@/components/mixins/AppOnlyInputNumbers'

export default {
  components: {
    Divider,
    AppLabel
  },

  mixins: [AppOnlyInputNumbers],

  props: {
    oficio: {
      required: true,
      type: Object
    },
    isMatricula: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    dataEmissao () {
      return utils.formatDate(this.oficio.dataEmissao)
    },

    numeroOficio: {
      get: function () {
        const numeroOficio = this.oficio.numeroOficio

        if (!numeroOficio) return ''

        return numeroOficio.substring(0, numeroOficio.indexOf('/'))
      },

      set: function (newValue) {
        if (/^\d{0,6}$/.test(newValue)) {
          this.oficio.numeroOficio = newValue + this.oficioSuffix
        }
      }
    },

    municipioNome () {
      if (this.oficio.cartorio.municipio) {
        return this.oficio.cartorio.municipio.nome
      }
    },

    oficioSuffix () {
      const ano = new Date().getFullYear()
      return '/' + ano + '/CPAT'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container-input {
  margin-right: 20px;
}

.input-suffix {
  padding: 10px;
}

>>> .el-input-group__append {
  color: $--color-text-secondary;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppDadosOficio.vue